module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Zerewan Heindrichs","short_name":"Zerewan Heindrichs","description":"Du hast die Idee – ich entwickle die passende Plattform.","background_color":"#16111e","theme_color":"#d3dbde","lang":"de","start_url":"/","display":"standalone","icon":"static/favicon.png","checkSupportedExtensions":false,"crossOrigin":"use-credentials","theme_color_in_head":true,"legacy":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"705c0ac66b64c7fa8bc883fa843beb54"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
